export default __webpack_public_path__ + "static/media/showMeOnScreen.bef951b5.svg";